<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.physicalExams', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group
                            id="exams-group"
                            :label="$tc('message.physicalExams', 1)"
                            label-for="exams"
                    >
                        <b-form-select
                                id="exams"
                                v-model="$v.form.examensClinique.$model"
                                :state="$v.form.examensClinique.$dirty ? !$v.form.examensClinique.$error : null"
                                :options="mExams"
                                multiple
                                required
                        ></b-form-select>

                        <b-form-invalid-feedback>
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" variant="primary">
                        {{ $t('message.add') }}
                    </b-button>

<!--                    <b-button type="reset" variant="danger">-->
<!--                        {{ $t('message.reset') }}-->
<!--                    </b-button>-->
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';

    export default {
        name: "AddPhysicalExam",

        computed: {
            ...mapGetters(["physicalExams", "hospitalisation"]),

            mExams: function() {
                let eArray = [];

                _.forOwn(this.physicalExams, function(value, key) {
                    eArray.push({ text: value.reference, value: value.id });
                });

                return eArray;
            },

            hospitalisation_id: function() {
                return this.hospitalisation.id;
            }
        },

        data() {
            return {
                form: {
                    examensClinique: [],
                },
                show: true
            }
        },

        methods: {
            getHospitalisation() {
                let args = {
                    hospitalisation: this.$route.params.hospitalisation
                };

                this.$store.dispatch("getHospitalisation", { args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        hospitalisation: this.hospitalisation_id,
                        examensClinique: this.form.examensClinique
                    };

                    let successMessage = this.$i18n.t('message.physicalExamCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createHospitalisationPhysicalExams', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.examensClinique = [];

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            }
        },

        validations: {
            form: {
                examensClinique: {
                    required
                }
            }
        },

        mounted() {
            this.getHospitalisation();
        }
    }
</script>

<style scoped>

</style>